import LocationOnIcon from '@mui/icons-material/LocationOn'
import { Box } from '@mui/material'
import { useTranslate } from 'ra-core'
import { TextField, useRecordContext } from 'react-admin'

import { INFO_WINDOW_TRANSLATION_KEY } from './AdvancedInfoWindow'
import FieldRow from './FieldRow'
import { SpeedLimitBadge } from './TelemacticContextSection'

const LocationField = ({ source = 'address' }) => {
  const { max_speed } = useRecordContext()
  const translate = useTranslate()
  return (
    <FieldRow icon={LocationOnIcon}>
      <Box sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField source={source} emptyText={translate(`${INFO_WINDOW_TRANSLATION_KEY}.noAddress`)} />
        {max_speed && <SpeedLimitBadge value={max_speed} />}
      </Box>
    </FieldRow>
  )
}

export default LocationField
